/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_PeriodInputs */



/**
* | output |
* | --- |
* | "Period" |
*
* @param {Usage_PeriodInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const usage_period = /** @type {((inputs?: Usage_PeriodInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_PeriodInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Période")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeitraum")
	if (locale === "it") return /** @type {LocalizedString} */ ("Periodo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Период")
	if (locale === "es") return /** @type {LocalizedString} */ ("Período")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("时期")
	if (locale === "ja") return /** @type {LocalizedString} */ ("期間")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अवधि")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Período")
	return /** @type {LocalizedString} */ ("Period")
});